import React from "react";
import { Grid } from "semantic-ui-react";
import { addItemsTabWarnings, deleteItemsTabWarnings } from '../../../commonActions/serverErrorAction';
import InputField from "../../../commonComponents/formComponents/inputField";
import { getValidationError as ValidationError } from '../../Helper'
import { GOODS_DESCRIPTION} from '../../Helper/formLabel'
import { useDispatch } from "react-redux";
import {
  saveLineItemFeild,
  updateLineItemFeild
} from "../../actions";
import usePdiEnable from "../../hooks/usePdiEnable";
 function CommercialDescription(props) {

  const {
    lineItemIndex,
    invoiceIndex,
    merchandiseId,
    commercialDescription,
    isFormDisabled,
    translate,
    invoiceId
    
  } = props;
  const dispatch = useDispatch();
  const getValidationError=(field, value, Level, onlyMandatoryCheck=false)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate)

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }
  const pdiDisabled = usePdiEnable();

  return (
    <Grid.Column width="7" className="divFormFeild b-rw-0 b-tlr-5">
      <InputField
        isLabel={false}
        id={`commercialDescription-${invoiceId}-${merchandiseId}`}
        type="text"
        boxNumber='31'
        label={translate(GOODS_DESCRIPTION,{ns:["default","lineItem"]})}
        mandatory={false}
        value={commercialDescription}
        className={"field-bg"}
        errors={getValidationError('commercialDescription', commercialDescription, 'itemsTab')}
        clearInput={false}
        disabled={isFormDisabled}
        {...pdiDisabled}
        onChange={(value) => {
          dispatch(updateLineItemFeild(invoiceId, merchandiseId, { commercialDescription: value }))

        }}
        onBlur={(value) => {
          dispatch(saveLineItemFeild(merchandiseId, 'commercialDescription', invoiceId))
          let err = getValidationError('commercialDescription', commercialDescription, 'itemsTab')
          err.length
          ? addErrors('itemsTab',`invoice - 00${invoiceIndex+1} :: line ${lineItemIndex+1}.`+ " :: " +err[0]  , `commercialDescription-${merchandiseId}`)
          : deleteErrors('itemsTab', '', `commercialDescription-${merchandiseId}`)
            
          
       
        }}
      />

    </Grid.Column>
  );
}


export default React.memo(CommercialDescription)